document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.kit-builder').forEach(initKitBuilder);
});

function initKitBuilder(root) {
  const form = root.querySelector('form[data-contact-form]');
  const cols = root.querySelectorAll('[data-step]');
  const pills = root.querySelectorAll('[data-step-pill]');
  const backBtn = root.querySelector('[data-nav="back"]');
  const nextBtn = root.querySelector('[data-nav="next"]');
  const submitBtn = root.querySelector('[data-nav="submit"]');
  const totalSteps = cols.length;
  let currentStep = 1;

  function showStep(step) {
    currentStep = step;
    cols.forEach(col => {
      col.classList.toggle('is-active', Number(col.dataset.step) === step);
    });
    pills.forEach(pill => {
      const n = Number(pill.dataset.stepPill);
      pill.classList.toggle('is-active', n === step);
      pill.classList.toggle('is-complete', n < step);
    });
    backBtn.style.visibility = step === 1 ? 'hidden' : 'visible';
    nextBtn.style.display = step === totalSteps ? 'none' : 'inline-flex';
    submitBtn.style.display = step === totalSteps ? 'inline-flex' : 'none';
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Allow clicking a pill to jump to a previously visited step
  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      const n = Number(pill.dataset.stepPill);
      if (n <= currentStep) showStep(n);
    });
  });

  backBtn.addEventListener('click', () => { if (currentStep > 1) showStep(currentStep - 1); });
  nextBtn.addEventListener('click', () => { if (currentStep < totalSteps) showStep(currentStep + 1); });

  const customQtyInput = form.querySelector('[data-qty-custom-input]');
  const qtyMinWarning = form.querySelector('[data-qty-min-warning]');

  function updateCustomQtyMin(kitInputEl) {
    const min = kitInputEl ? Number(kitInputEl.dataset.kitMin || 5) : 5;
    customQtyInput.min = min;
    checkQtyMinWarning();
  }

  function checkQtyMinWarning() {
    const val = Number(customQtyInput.value);
    const min = Number(customQtyInput.min || 5);
    if (customQtyInput.value.trim() !== '' && val < min) {
      qtyMinWarning.textContent = `Heads up — this kit's minimum is ${min}. You can still submit; we'll confirm the right minimum with you.`;
      qtyMinWarning.hidden = false;
    } else {
      qtyMinWarning.hidden = true;
    }
  }

  // Selected-card styling
  form.addEventListener('change', (e) => {
    if (e.target.type === 'radio') {
      const name = e.target.name;
      form.querySelectorAll(`input[name="${CSS.escape(name)}"]`).forEach(input => {
        input.closest('label').classList.toggle('is-selected', input.checked);
      });
    }
    if (e.target.hasAttribute('data-qty-preset') && e.target.checked) {
      // Picking a preset quantity clears any custom value
      customQtyInput.value = '';
      qtyMinWarning.hidden = true;
    }
    if (e.target.name === 'contact[kit]') {
      filterProductsByKit(e.target.value);
      updateCustomQtyMin(e.target);
    }
    updateSummary();
  });

  // Typing a custom quantity deselects the preset radios
  customQtyInput.addEventListener('input', () => {
    if (customQtyInput.value.trim() !== '') {
      form.querySelectorAll('[data-qty-preset]').forEach(r => {
        r.checked = false;
        r.closest('label').classList.remove('is-selected');
      });
    }
    checkQtyMinWarning();
    updateSummary();
  });

  function filterProductsByKit(kitKey) {
    root.querySelectorAll('[data-kit-filter]').forEach(label => {
      const allowed = label.dataset.kitFilter;
      const allowedList = allowed.split(',').map(s => s.trim()).filter(Boolean);
      const show = allowedList.length === 0 || allowedList.includes(kitKey.toLowerCase());
      label.style.display = show ? '' : 'none';
    });
    // Hide entire category (e.g. Layer) if no visible options remain,
    // and uncheck any option inside it so its price delta stops counting
    root.querySelectorAll('.kit-builder__category').forEach(cat => {
      const optionLabels = Array.from(cat.querySelectorAll('[data-kit-filter]'));
      const visible = optionLabels.some(l => l.style.display !== 'none');
      cat.style.display = visible ? '' : 'none';
      if (!visible) {
        optionLabels.forEach(l => {
          const input = l.querySelector('input');
          if (input && input.checked) {
            input.checked = false;
            l.classList.remove('is-selected');
          }
        });
      }
    });
  }

  function currency(n) {
    return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function updateSummary() {
    const kitInput = form.querySelector('input[name="contact[kit]"]:checked');
    const qtyInput = form.querySelector('input[name="contact[quantity]"]:checked');
    const basePrice = kitInput ? Number(kitInput.dataset.kitPrice || 0) : 0;
    const customQty = customQtyInput && customQtyInput.value.trim() !== '' ? Number(customQtyInput.value) : null;
    const qty = customQty !== null ? customQty : (qtyInput ? Number(qtyInput.dataset.qty || 0) : 0);

    let delta = 0;
    ['Polo', 'Hat', 'Layer', 'Bag', 'Tee'].forEach(cat => {
      const checked = form.querySelector(`input[name="contact[${cat.toLowerCase()}]"]:checked`);
      if (checked) delta += Number(checked.dataset.priceDelta || 0);
    });

    const pricePerPerson = basePrice + delta;
    const total = pricePerPerson * qty;

    const kitNameEl = root.querySelector('[data-summary-kit-name]');
    const kitLabel = kitInput ? kitInput.closest('label').querySelector('.kit-builder__kit-name')?.textContent : null;
    if (kitNameEl && kitLabel) kitNameEl.textContent = kitLabel;

    root.querySelector('[data-summary-qty]').textContent = qty ? qty + ' kits' : '—';
    root.querySelector('[data-summary-price]').textContent = basePrice ? currency(pricePerPerson) : '—';
    root.querySelector('[data-summary-total]').textContent = (basePrice && qty) ? currency(total) : '—';
  }

  // Build a human-readable summary into the hidden textarea before submit
  form.addEventListener('submit', () => {
    const get = (name) => {
      const el = form.querySelector(`[name="contact[${name}]"]:checked, [name="contact[${name}]"]`);
      return el ? el.value : '';
    };
    const kitInput = form.querySelector('input[name="contact[kit]"]:checked');
    const qtyInput = form.querySelector('input[name="contact[quantity]"]:checked');
    const customQty = customQtyInput && customQtyInput.value.trim() !== '' ? customQtyInput.value : null;
    const lines = [
      'NIKE KIT BUILDER REQUEST',
      '-------------------------',
      'Kit: ' + (kitInput ? kitInput.closest('label').querySelector('.kit-builder__kit-name')?.textContent : ''),
      'Quantity: ' + (customQty !== null ? customQty : (qtyInput ? qtyInput.value : '')),
      'Polo: ' + get('polo'),
      'Hat: ' + get('hat'),
      'Layer: ' + get('layer'),
      'Bag: ' + get('bag'),
      'Tee: ' + get('tee'),
      'Logo color: ' + get('logo_color'),
      'Placement: ' + get('placement'),
      'Logo link: ' + get('logo_link'),
      'Company: ' + get('company_name'),
      'Notes: ' + get('notes'),
      'Target in-hand date: ' + get('target_date'),
    ];
    form.querySelector('[id^="kit-builder-summary-"]').value = lines.join('\n');
  });

 showStep(1);

  const initialKit = form.querySelector('input[name="contact[kit]"]:checked');
  if (initialKit) {
    filterProductsByKit(initialKit.value);
    updateCustomQtyMin(initialKit);
  }
  updateSummary();
}
